import React from 'react';

const TipoDocumentoContext = React.createContext();

export default TipoDocumentoContext;
